import React, { useState, useEffect, useMemo, lazy, Suspense } from 'react';
import './global-loader.scss';

const DotLottieReact = lazy(() =>
  import('@lottiefiles/dotlottie-react').then((mod) => ({
    default: mod.DotLottieReact,
  }))
);

interface GlobalLoaderProps {
  isVisible: boolean;
  message?: string;
  lottieSrc?: string;
  type?: 'default' | 'auth' | 'critical';
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ 
  isVisible, 
  message = "",
  lottieSrc,
  type = 'default',
}) => {
  const [shouldRender, setShouldRender] = useState(isVisible);
  const [isExiting, setIsExiting] = useState(false);

  const memoizedLottieSrc = useMemo(() => {
    if (lottieSrc) return lottieSrc;
    
    switch (type) {
      case 'auth':
        return "https://lottie.host/9920b30b-dfd8-4281-b64b-fef1a1689b4b/ki6hnhiHZk.lottie";
      case 'critical':
        return "https://lottie.host/9920b30b-dfd8-4281-b64b-fef1a1689b4b/ki6hnhiHZk.lottie";
      default:
        return "https://lottie.host/9920b30b-dfd8-4281-b64b-fef1a1689b4b/ki6hnhiHZk.lottie";
    }
  }, [lottieSrc, type]);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      setIsExiting(false);
      document.body.style.overflow = 'hidden';
    } else {
      setIsExiting(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        document.body.style.overflow = '';
      }, 300);
      return () => clearTimeout(timer);
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div 
      className={`global-loader-overlay ${isExiting ? 'fade-out' : ''}`}
    >
      <div className="global-loader-container">
        <div className="lottie-loader-wrapper">
          <Suspense
            fallback={
              <div className="global-loader__lottie-placeholder" aria-hidden="true" />
            }
          >
            <div className="global-loader__lottie">
              <DotLottieReact
                src={memoizedLottieSrc}
                loop
                autoplay
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
